import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  commonPageFieldList,
  commonPageFieldListSuccess,
  getpdfReportdata,
} from "../../../store/actions";
import SchemeMaster from "./SchemeMaster";
import {
  DeleteCompanyVoucher,
  DeleteGiftVouchersByScheme,
  DeleteGiftVouchersBySchemeSuccess,
  Upload_Voucher,
  Upload_Voucher_Success,
  deleteSchemelistSuccess,
  delete_SchemeList_ID,
  editSchemeID,
  getSchemeList,
  getSchemeListSuccess,
  saveSchemeMaster_Success,
  updateSchemeID,
  updateSchemeIDSuccess
} from "../../../store/Administrator/SchemeMasterRedux/action";
import * as pageId from "../../../routes/allPageID"
import * as url from "../../../routes/route_url";
import { C_Button, Go_Button, PageLoadingSpinner } from "../../../components/Common/CommonButton";
import CommonPurchaseList from "../../../components/Common/CommonPurchaseList";
import * as report from '../../../Reports/ReportIndex'
import { Button, Col, FormGroup, Label, Modal, Row, Spinner } from "reactstrap";
import Dropzone from "react-dropzone";
import * as XLSX from 'xlsx';
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import { C_DatePicker, C_Select } from "../../../CustomValidateForm";
import * as _cfunc from "../../../components/Common/CommonFunction";
import moment from "moment";
import { edit_Scheme_List_Api, Get_Scheme_List, PartiesOnPartyType_API } from "../../../helpers/backend_helper";
import { ExcelReportComponent } from "../../../components/Common/ReportCommonFunc/ExcelDownloadWithCSS";
import C_Report from "../../../components/Common/C_Report";
import { alertMessages } from "../../../components/Common/CommonErrorMsg/alertMsg";
import { columns as schemeReportColumns, Rows as schemeReportRows } from "../../../Reports/SchemeMasterReport/TableData";


const SchemeMasterList = () => {





  const dispatch = useDispatch();
  const IsSCMCompany = _cfunc.loginIsSCMCompany()
  const [ModalOpen, setModalOpen] = useState({ Open: false, Data: null });
  const [borderStyle, setBorderStyle] = useState("2px dashed #ced4da");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [validJsonData, setValidJsonData] = useState(null); // Store valid JSON data
  const [hederFilters, setHederFilters] = useState({ fromdate: _cfunc.currentDate_ymd, todate: _cfunc.currentDate_ymd })
  const { fromdate, todate, } = hederFilters;
  const [fileStatus, setFileStatus] = useState(null); // "valid" | "invalid" | null
  const [message, setMessage] = useState("");
  const [showExpiryModal, setShowExpiryModal] = useState({ Show: false, Data: [], Id: null });
  
  const [voucherMeta, setVoucherMeta] = useState({
    validFrom: _cfunc.currentDate_ymd,
    validTo: _cfunc.currentDate_ymd,
    voucherCount: 0,
    amount: ""
  });
  const [channelType, setChannelType] = useState({
    value: null,
    label: "All"
  });
  const [channelOptions, setChannelOptions] = useState([]);
  const [deleteRowLoading, setDeleteRowLoading] = useState(null);
  const [hoveredRow, setHoveredRow] = useState(null);

  const reducers = useSelector(
    (state) => ({
      listBtnLoading: state.SchemeReducer.listBtnLoading || state.PdfReportReducers.listBtnLoading || state.PdfReportReducers.ReportBtnLoading,
      reportResponse: state.SchemeReducer.reportResponse,
      goBtnLoading: state.SchemeReducer.goBtnLoading,        // Show button (unchanged)
      printBtnLoading: state.PdfReportReducers.goBtnLoading, // NEW — Print button, mirrors SNSReport's `goBtnLoading`
      pdfdata: state.PdfReportReducers.pdfdata,               // NEW
      tableList: state.SchemeReducer.SchemeList,
      UploadBtnloading: state.SchemeReducer.UploadBtnloading,
      deleteVoucherMsg: state.SchemeReducer.deleteVoucherMsg,
      editData: state.SchemeReducer.editData,
      deleteVoucherLoading: state.SchemeReducer.deleteVoucherLoading,
      updateMsg: state.SchemeReducer.updateMsg,
      UploadMsg: state.SchemeReducer.UploadMsg,
      deleteMsg: state.SchemeReducer.deleteMsg,
      postMsg: state.SchemeReducer.postMsg,
      userAccess: state.Login.RoleAccessUpdateData,
      pageField: state.CommonPageFieldReducer.pageFieldList,
      Parties: state.PartyTypeReducer.ListData,
    })
  );

  const { UploadBtnloading, reportResponse, deleteVoucherMsg, deleteVoucherLoading, UploadMsg, listBtnLoading, printBtnLoading, pdfdata, Parties, } = reducers;


  const action = {
    getList: getSchemeList,
    editId: editSchemeID,
    deleteId: delete_SchemeList_ID,
    postSucc: saveSchemeMaster_Success,
    updateSucc: updateSchemeIDSuccess,
    deleteSucc: deleteSchemelistSuccess
  }

  useEffect(() => {
    const page_Id = pageId.SCHEME_MASTER_lIST
    dispatch(commonPageFieldListSuccess(null))
    dispatch(commonPageFieldList(page_Id))
    goButtonHandler();
  }, []);


  function upBtnFunc(config) {
    setModalOpen({ Open: true, Data: config.rowData });
  }

  useEffect(() => {
    let mounted = true;

    const fetchChannelOptions = async () => {
      try {
        const resp = await PartiesOnPartyType_API(42); // 👈 ID = 42 Scheme Type HardCoded PartyTye

        if (
          resp?.StatusCode === 200 &&
          Array.isArray(resp.Data)
        ) {
          const options = [
            {
              value: null,
              label: "All"
            },
            ...resp.Data.map(item => ({
              value: item.id,
              label: item.Name,
            }))
          ];

          if (mounted) {
            setChannelOptions(options);

            setChannelType({
              value: null,
              label: "All"
            });
          }
        } else {
          if (mounted) setChannelOptions([]);
        }
      } catch (err) {
        console.error("Channel option fetch error", err);
        if (mounted) setChannelOptions([]);
      }
    };

    fetchChannelOptions();
    return () => { mounted = false };
  }, []);

  useEffect(() => {
    try {
      if (
        reducers.reportResponse.Status === true &&
        reducers.reportResponse.StatusCode === 200
      ) {
        if (reducers.reportResponse.Mode === "Excel") {
          generateSchemeMasterExcel(reducers.reportResponse.Data);
        }
        // Show: do nothing — SchemeList already holds the fetched rows, leave it alone
      }
    } catch (e) { }
  }, [reducers.reportResponse]);

  useEffect(() => {
    try {
      if ((pdfdata.Status === true) && (pdfdata.StatusCode === 204)) {
        customAlert({ Type: 3, Message: alertMessages.recordNotAvailable });
      }
    } catch (e) { }
  }, [pdfdata]);


  const handleFile = (rowData) => {
    if (!uploadedFile) return;

    // ✅ Step 1: Check file type
    if (!uploadedFile.name.endsWith(".csv") && !uploadedFile.name.endsWith(".xlsx")) {
      setFileStatus("invalid");
      setMessage("Only CSV or Excel files are allowed.");
      return;
    }

    const reader = new FileReader();


    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);

      // ✅ Step 2: Parse Excel file
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // ✅ Convert to JSON (object format based on headers)
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

      // ✅ Extract column headers
      const headers = Object.keys(jsonData[0] || {});

      // 👉 Define required headers
      const requiredHeaders = ["Voucher"]; // put your expected column names here

      // ✅ Check if all required headers are present
      const missingHeaders = requiredHeaders.filter(h => !headers.includes(h));

      if (missingHeaders.length > 0) {
        setFileStatus("invalid");
        setMessage(`Column Header Missing: ${missingHeaders.join(", ")}`);
        return; // stop here, don’t continue further validation
      }

      // ✅ Optional: Validate based on prefix (only if headers are correct)
      const prefix = rowData?.QRPrefix;
      const isValid = jsonData.every(row =>
        row[Object.keys(row)[0]] && String(row[Object.keys(row)[0]]).startsWith(prefix)
      );

      if (isValid) {
        setFileStatus("valid");
        setMessage(`${uploadedFile.name} is a valid file.`);
        setValidJsonData(jsonData); // Store valid JSON data for further processing
        setVoucherMeta(prev => ({
          ...prev,
          voucherCount: jsonData.length
        }));
      } else {
        setFileStatus("invalid");
        setMessage(`Each value in the first column must start with '${prefix}'.`);
      }
    };


    reader.readAsArrayBuffer(uploadedFile);
  };
  const finalValidityTo = _cfunc.ToDate({
    FromDate: voucherMeta.validFrom,
    Todate: voucherMeta.validTo
  });

  const validateBeforeUpload = () => {
    let errors = {};

    // Date validation
    if (!voucherMeta.validFrom) {
      errors.validFrom = "Validity From is required";
    }

    if (!voucherMeta.validTo) {
      errors.validTo = "Validity To is required";
    }

    if (
      voucherMeta.validFrom &&
      voucherMeta.validTo &&
      moment(finalValidityTo).isBefore(voucherMeta.validFrom, "day")
    ) {
      errors.validTo = "Validity To must be greater than or equal to Validity From";
    }


    // File validation
    if (!validJsonData || !validJsonData.length) {
      errors.file = "Please validate and upload a file";
    }

    if (Object.keys(errors).length > 0) {
      customAlert({
        Type: 3,
        Message: Object.values(errors).join("\n"),
      });
      return false;
    }

    return true;
  };


  const uploadFile = () => {
    if (!validateBeforeUpload()) return;

    const jsonBody = JSON.stringify({
      Scheme: ModalOpen.Data.id,
      PartyID: channelType?.value ?? null,
      Amount: voucherMeta.amount ? Number(voucherMeta.amount) : null,
      ValidityFrom: voucherMeta.validFrom,
      ValidityTo: finalValidityTo,
      VoucherCount: voucherMeta.voucherCount,
      Data: validJsonData,
    });

    dispatch(Upload_Voucher({ jsonBody }));
  };


  function tog_backdrop() {
    setModalOpen({ Open: false, Data: null });
    setUploadedFile(null);
    setBorderStyle("2px dashed #ced4da");
    setFileStatus(null);
    setMessage("");
    setValidJsonData(null); // Reset valid JSON data
    removeBodyCss()
    setVoucherMeta({
      validFrom: _cfunc.currentDate_ymd,
      validTo: _cfunc.currentDate_ymd,
      amount: ""

    });
    setChannelType({
      value: null,
      label: "All"
    });
  }


  function toggle() {
    setShowExpiryModal({ Show: false, Data: [], Id: null })

  }
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }


  useEffect(() => {
    if (UploadMsg && UploadMsg.Message) {

      const isSuccess =
        UploadMsg.Status === true &&
        UploadMsg.StatusCode === 200;

      customAlert({
        Type: isSuccess ? 1 : 4,
        Message: JSON.stringify(UploadMsg.Message),
      });

      if (isSuccess) {


        goButtonHandler();
      }

      setUploadedFile(null);
      setBorderStyle("2px dashed #ced4da");
      setFileStatus(null);
      setMessage("");
      setValidJsonData(null);
      setModalOpen({ Open: false, Data: null });
      setChannelType({
        value: null,
        label: "All"
      });
      setVoucherMeta({
        validFrom: _cfunc.currentDate_ymd,
        validTo: _cfunc.currentDate_ymd,
      });

      dispatch(
        Upload_Voucher_Success({
          Status: false,
          StatusCode: null,
          Message: "",
        })
      );
    }
  }, [UploadMsg]);
  // [UploadMsg, dispatch]);

  function todateOnchange(e, date) {
    let newObj = { ...hederFilters }
    newObj.todate = date
    setHederFilters(newObj)
  }

  function fromdateOnchange(e, date) {
    let newObj = { ...hederFilters }
    newObj.fromdate = date
    setHederFilters(newObj)
  }

  const goButtonHandler = (mode = "Show") => {
    let config = {};

    const jsonBody = JSON.stringify({
      FromDate: fromdate,
      ToDate: todate,
    });

    config.jsonBody = jsonBody;
    config.Mode = mode;

    dispatch(getSchemeList(config));
  }

  const excelHandler = () => {
    const jsonBody = JSON.stringify({ FromDate: fromdate, ToDate: todate });
    const config = { jsonBody, Mode: "Excel", ReportType: report.schemeMaster };
    dispatch(getSchemeList(config));
  };

  const printHandler = () => {
    const jsonBody = JSON.stringify({ FromDate: fromdate, ToDate: todate });
    sessionStorage.setItem("SchemeReportDateRange", JSON.stringify({ fromDate: fromdate, toDate: todate })); // ⭐ added
    const config = { jsonBody, ReportType: report.schemeMaster };
    dispatch(getpdfReportdata(Get_Scheme_List, config));
  };

  const generateSchemeMasterExcel = (schemes) => {
    // Rows() includes a trailing "row"/"subtotal"/"grandtotal" marker used
    // only by the PDF's didParseCell — not meant for display, so it's
    // dropped here before building the Excel sheet.
    const dataRows = schemeReportRows(schemes).map(row => row.slice(0, 8)); // ⭐ was 7

    const aoa = [
      schemeReportColumns,
      ...dataRows,
    ];
    const worksheet = XLSX.utils.aoa_to_sheet(aoa);

    worksheet["!cols"] = [
      { wch: 50 }, // Scheme Name
      { wch: 50 }, // Customer Company
      { wch: 14 }, // Validity From
      { wch: 14 }, // Validity To
      { wch: 14 }, // Voucher Amount   ⭐ NEW
      { wch: 14 }, // Bill Amount
      { wch: 12 }, // Total Coupon
      { wch: 12 }, // Used Coupon
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Scheme Master Report");
    XLSX.writeFile(workbook, "Scheme_Master_Report.xlsx");
  };

  const UpdateExpiryFunc = async (row) => {
    const resp = await edit_Scheme_List_Api({ editId: row.editId })
    setShowExpiryModal({ Show: true, Data: resp.Data[0], Id: row.editId })
  };


  // const handleSave = () => {
  //   const jsonBody = JSON.stringify(showExpiryModal.Data)
  //   dispatch(updateSchemeID({ jsonBody, updateId: showExpiryModal.Id, }));
  //   setShowExpiryModal({ Show: false, Data: [], Id: null })
  // }

  const handleSave = () => {

    const payload = {
      ...showExpiryModal.Data,
      QRPrefix: showExpiryModal.Data.QrPrefix
    };

    delete payload.QrPrefix;

    payload.ItemDetails = payload.ItemDetails?.map(item => ({
      Item: item.ItemID,
      TypeForItem: item.applicable
        ? 1
        : item.not_applicable
          ? 2
          : 3,
      DiscountType: item.DiscountType,
      DiscountValue: item.DiscountValue,
      Quantity: item.Quantity,
    }));

    const jsonBody = JSON.stringify(payload);

    dispatch(updateSchemeID({
      jsonBody,
      updateId: showExpiryModal.Id,
    }));

    setShowExpiryModal({
      Show: false,
      Data: [],
      Id: null
    });
  };




  function validityFromOnchange(e, date) {
    setVoucherMeta(prev => ({
      ...prev,
      validFrom: date,
    }));
  }

  function validityToOnchange(e, date) {
    setVoucherMeta(prev => ({
      ...prev,
      validTo: date,
    }));
  }

  const handleDownload = (rowData) => {
    const schemePrefix = rowData?.QRPrefix;
    const worksheetData = [
      ["Voucher"],              // header
      [`${schemePrefix}1`],     // row 1
      [`${schemePrefix}2`],     // row 2
      [`${schemePrefix}3`]      // row 3
    ];

    // Create worksheet & workbook
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "DemoFormat");

    // Trigger download
    XLSX.writeFile(workbook, "Demo_Format.xlsx");
  };



  const handleDeleteCompanyVoucher = (item) => {

    customAlert({
      Type: 6,
      Message: `Are you sure you want to delete vouchers for "${item.PartyName || "All"}" ?`,
      PermissionFunction: () => {

        setDeleteRowLoading(item.Party);

        const jsonBody = JSON.stringify({
          SchemeID: item.Scheme,
          PartyID: item.Party ?? null,
        });

        dispatch(
          DeleteGiftVouchersByScheme({
            jsonBody,
          })
        );
      }
    });

  };

  useEffect(() => {

    if ((deleteVoucherMsg.Status === true) && (deleteVoucherMsg.StatusCode === 200)) {
      setDeleteRowLoading(null);

      customAlert({
        Type: 1,
        Message: JSON.stringify(deleteVoucherMsg.Message),
      });

      setModalOpen({ Open: false, Data: null });

      goButtonHandler(); // <-- Success nantar API hit
      dispatch(DeleteGiftVouchersBySchemeSuccess({ Status: false }));

    } else if (deleteVoucherMsg.Status === true) {

      setDeleteRowLoading(null);

      customAlert({
        Type: 4,
        Message: JSON.stringify(deleteVoucherMsg.Message),
      });

      dispatch(DeleteGiftVouchersBySchemeSuccess({ Status: false }));
    }

  }, [deleteVoucherMsg]);

  useEffect(() => {
    if (!deleteVoucherLoading) {
      setDeleteRowLoading(null);
    }
  }, [deleteVoucherLoading]);


  const { pageField, goBtnLoading } = reducers
  return (
    <React.Fragment>
      <PageLoadingSpinner isLoading={(goBtnLoading || !pageField)} />

      <>
        <div className="px-2   c_card_filter text-black" >
          <div className="row" >
            <Col sm="3" className="">
              <FormGroup className="mb-1 row mt-2 " >
                <Label className="col-sm-5 p-2"
                  style={{ width: "83px" }}>FromDate</Label>
                <Col sm="7">
                  <C_DatePicker
                    name='FromDate'
                    value={fromdate}
                    onChange={fromdateOnchange}
                  />
                </Col>
              </FormGroup>
            </Col>

            <Col sm="3" className="">
              <FormGroup className="mb-1 row mt-2 " >
                <Label className="col-sm-5 p-2"
                  style={{ width: "65px" }}>ToDate</Label>
                <Col sm="7">
                  <C_DatePicker
                    options={{
                      minDate: (_cfunc.disablePriviousTodate({ fromDate: fromdate })),
                      maxDate: "today",
                      altInput: true,
                      altFormat: "d-m-Y",
                      dateFormat: "Y-m-d",
                    }}

                    value={_cfunc.ToDate({ FromDate: fromdate, Todate: todate })}
                    name="ToDate"
                    onChange={todateOnchange}
                  />
                </Col>
              </FormGroup>
            </Col>

            <Col sm="4"></Col>

            <Col sm="2" className="d-flex justify-content-end">
              <C_Button
                type="button"
                spinnerColor="white"
                loading={goBtnLoading}
                className="btn btn-success m-2 mr"
                onClick={() => goButtonHandler("Show")}
              >
                Show
              </C_Button>

              <C_Button
                type="button"
                spinnerColor="white"
                loading={listBtnLoading === "Excel"}
                className="btn btn-primary m-2 mt-2 mr"
                onClick={excelHandler}
              >
                Excel
              </C_Button>

              <C_Button
                type="button"
                spinnerColor="white"
                loading={printBtnLoading}
                className="btn btn-secondary m-2 mt-2 mr"
                onClick={printHandler}
              >
                Print
              </C_Button>
            </Col>
          </div>
        </div>
      </>
      {
        (pageField) &&
        <CommonPurchaseList
          action={action}
          UpdateExpiryFunc={UpdateExpiryFunc}
          reducers={reducers}
          showBreadcrumb={false}
          upBtnFunc={upBtnFunc}
          MasterModal={SchemeMaster}
          masterPath={url.SCHEME_MASTER}
          newBtnPath={url.SCHEME_MASTER}
          ButtonMsgLable={"Scheme"}
          deleteName={"SchemeName"}
          goButnFunc={goButtonHandler}
        />
      }

      <Modal
        isOpen={ModalOpen.Open}
        toggle={() => {
          tog_backdrop()
        }}
        className="modal-dialog-centered"
      >
        <div
          className=""
          style={{ width: "200%", margin: "auto" }}
        >
          <div className="p-4 bg-light rounded shadow-sm">
            <h3 className="mb-3 text-center">Upload Voucher</h3>
            <hr />

            <div className="text-center mb-1">
              <h5
                className="fw-bold text-primary"
                style={{ wordBreak: "break-word" }}
              >
                {ModalOpen?.Data?.SchemeName}
              </h5>
            </div>

            <Row className="mb-4">
              <Col>
                <div className="bg-white p-3 rounded shadow-sm border mt-3">
                  <h6 className="text-primary mb-2">Previous Voucher Detail</h6>
                  <div className="d-flex justify-content-between align-items-center flex-wrap">

                    {/* Voucher counts displayed horizontally with spacing */}
                    <div
                      className="d-flex flex-wrap align-items-center"
                      style={{
                        gap: "65px",
                        fontSize: "16px"
                      }}
                    >
                      <div>
                        <strong>Total:</strong>{" "}
                        {ModalOpen?.Data?.TotalVoucherCodeCount}
                      </div>

                      <div>
                        <strong>Active:</strong>{" "}
                        <span
                          className="text-success fw-bold"
                          style={{ fontSize: "16px" }}
                        >
                          {ModalOpen?.Data?.ActiveVoucherCodeCount}
                        </span>
                      </div>

                      <div>
                        <strong>Inactive:</strong>{" "}
                        <span
                          className="text-danger fw-bold"
                          style={{ fontSize: "16px" }}
                        >
                          {ModalOpen?.Data?.InactiveVoucherCodeCount}
                        </span>
                      </div>
                    </div>

                  </div>
                </div>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col sm="3">
                <FormGroup>
                  <Label>
                    Party
                  </Label>
                  <C_Select
                    value={channelType}
                    options={channelOptions}
                    onChange={(e) => {
                      setChannelType(e);
                    }}
                  />
                </FormGroup>
              </Col>
              <Col sm="3">
                <FormGroup>
                  <Label>Validity From</Label>
                  <C_DatePicker
                    name="ValidityFrom"
                    options={{
                      minDate: ModalOpen?.Data?.FromPeriod,
                      maxDate: ModalOpen?.Data?.ToPeriod,
                      altInput: true,
                      altFormat: "d-m-Y",
                      dateFormat: "Y-m-d",
                    }}
                    value={voucherMeta.validFrom}
                    onChange={validityFromOnchange}
                  />
                </FormGroup>
              </Col>

              <Col sm="3">
                <FormGroup>
                  <Label>Validity To</Label>
                  <C_DatePicker
                    options={{
                      minDate: _cfunc.disablePriviousTodate({
                        fromDate: voucherMeta.validFrom
                      }),
                      maxDate: ModalOpen?.Data?.ToPeriod, // Main Scheme End Date
                      minDate: voucherMeta.validFrom,
                      altInput: true,

                      altFormat: "d-m-Y",
                      dateFormat: "Y-m-d",
                    }}
                    value={_cfunc.ToDate({
                      FromDate: voucherMeta.validFrom,
                      Todate: voucherMeta.validTo
                    })}
                    name="ValidityTo"
                    onChange={validityToOnchange}
                  />
                </FormGroup>
              </Col>

              <Col sm="3">
                <FormGroup>

                  <Label>Amount</Label>

                  <input
                    className="form-control"
                    placeholder="Enter Amount"
                    type="number"
                    min="1"
                    value={voucherMeta.amount}
                    onChange={(e) => {

                      setVoucherMeta(prev => ({

                        ...prev,
                        amount: e.target.value

                      }))

                    }}
                  />

                </FormGroup>
              </Col>
            </Row>

            <Row className="mb-2">
              <Col className="text-start ms-1">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDownload(ModalOpen.Data);
                  }}
                  className="text-primary"
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                >
                  Download Demo Format
                </a>
              </Col>
            </Row>
            <Row className="mb-4">

              <Col sm='3'>
                <Dropzone
                  onDrop={(acceptedFiles) => {
                    const file = acceptedFiles[0];
                    setUploadedFile(file);
                    setBorderStyle("3px dotted green");
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div
                      {...getRootProps()}
                      style={{
                        border: borderStyle,
                        height: "150px",
                        padding: '20px',      // 30 -> 10
                        textAlign: 'center',
                        backgroundColor: '#f8f9fa',
                        cursor: 'pointer',
                        borderRadius: '10px',
                        transition: 'border 0.3s ease'
                      }}
                    >
                      <input {...getInputProps()} />

                      <i
                        className="text-muted bx bxs-cloud-upload"
                        style={{ fontSize: "20px" }}   // display-4 kadhla
                      />

                      <h6 className="text-muted mb-0 mt-1 " style={{ fontSize: "15px" }}>
                        {uploadedFile
                          ? uploadedFile.name
                          : "Drop files here or click to upload."}
                      </h6>
                    </div>
                  )}
                </Dropzone>
              </Col>


              <Col sm='9'>
                <div
                  className="bg-white rounded p-2"
                  style={{
                    width: "100%",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    border: "1px solid #e9ecef"
                  }}
                >
                  <h6
                    className="mb-2"
                    style={{
                      color: "#556ee6",
                      fontWeight: "500"
                    }}
                  >
                    Customer Company Details
                  </h6>

                  <div className="table-responsive">
                    <table className="table table-hover table-sm mb-0 w-100">
                      <thead
                        style={{
                          backgroundColor: "#f8f9fa"
                        }}
                      >
                        <tr>
                          <th style={{ fontWeight: "500" }}>
                            Customer Company
                          </th>

                          <th className="text-end">
                            Amount
                          </th>

                          <th
                            className="text-end"
                            style={{ fontWeight: "500" }}
                          >
                            Coupon Count
                          </th>

                          <th
                            className="text-center"
                            style={{ fontWeight: "500" }}
                          >
                            Validity From
                          </th>

                          <th
                            className="text-center"
                            style={{ fontWeight: "500" }}
                          >
                            Validity To
                          </th>
                          <th
                            className="text-center"
                            style={{ fontWeight: "500" }}
                          >
                            Action
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {ModalOpen?.Data?.SchemeCustomerCompanyList?.length > 0 ? (
                          ModalOpen.Data.SchemeCustomerCompanyList.map((item, index) => (
                            <tr key={index}>
                              <td
                                style={{
                                  whiteSpace: "normal",
                                  wordBreak: "break-word"
                                }}
                              >
                                {item.PartyName || "All"}
                              </td>
                              <td className="text-end">
                                {item.Amount ?? 0}
                              </td>

                              <td
                                className="text-end position-relative"
                                onMouseEnter={() => setHoveredRow(index)}
                                onMouseLeave={() => setHoveredRow(null)}
                              >
                                <span
                                  className="fw-bold text-primary"
                                  style={{
                                    cursor: "pointer",
                                    textDecoration: "underline"
                                  }}
                                >
                                  {item.VoucherCount}
                                </span>

                                {hoveredRow === index && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "-50px",
                                      right: "0",
                                      background: "#fff",
                                      border: "1px solid #dee2e6",
                                      borderRadius: "8px",
                                      padding: "10px 16px",
                                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                      zIndex: 99999,
                                      whiteSpace: "nowrap",
                                      minWidth: "320px",
                                      fontWeight: "500"
                                    }}
                                  >
                                    <div style={{ textAlign: "center", }} className="text-primary">
                                      <p>Coupon Info</p>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "30px",
                                        fontSize: "14px",
                                        alignItems: "center"
                                      }}
                                    >

                                      <span className="ms-4">
                                        Total: <b>{(item.ActiveVoucher) + (item.InactiveVoucher)}</b>
                                      </span>

                                      <span className="text-success">
                                        Used: <b>{item.InactiveVoucher}</b>
                                      </span>

                                      <span className="text-danger">
                                        Unused: <b>{item.ActiveVoucher}</b>
                                      </span>
                                    </div>
                                  </div>
                                )}
                              </td>

                              <td className="text-center">
                                {_cfunc.date_dmy_func(item.ValidityFrom)}
                              </td>

                              <td className="text-center">
                                {_cfunc.date_dmy_func(item.ValidityTo)}
                              </td>
                              <td className="text-center">
                                <Button
                                  color="danger"
                                  size="sm"
                                  onClick={() => handleDeleteCompanyVoucher(item)}
                                  disabled={
                                    Number(item.ActiveVoucher) === 0 ||
                                    (deleteVoucherLoading &&
                                      deleteRowLoading === item.Party)
                                  }
                                >
                                  {deleteVoucherLoading &&
                                    deleteRowLoading === item.Party ? (
                                    <Spinner
                                      size="sm"
                                      color="light"
                                    />
                                  ) : (
                                    <i className="bx bxs-trash"></i>
                                  )}
                                </Button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" className="text-center text-muted">
                              No Data Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>


            </Row>

            <Row>
              {fileStatus === "valid" ? <Col xs="auto">
                <Button className="btn btn-success" onClick={uploadFile} disabled={UploadBtnloading}>
                  {UploadBtnloading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      <span className="invisible ms-xxl-n5">Upload</span> {/* Keeps spacing and width */}

                    </>
                  ) : (
                    "Upload"
                  )}
                </Button>

              </Col>
                :
                <Col xs="auto">
                  <Button
                    className="btn btn-primary"
                    onClick={() => {
                      handleFile(ModalOpen.Data)
                    }}
                  >
                    Validate
                  </Button>

                </Col>}

              <Col className="col">
                <div className="bg-white py-xxl-1 rounded shadow-sm" style={{ height: "32px" }}>
                  {fileStatus === "valid" && (
                    <>
                      {message?.split('\n').map((msg, index) => (
                        <li key={index} className="text-success d-flex align-items-start">
                          <i className="mdi mdi-check-decagram text-success me-2 font-size-16  px-1"></i>
                          <span>{msg}</span>
                        </li>
                      ))}
                    </>
                  )}

                  {fileStatus === "invalid" && (
                    <>
                      {message?.split('\n').map((msg, index) => (
                        <li key={index} className="text-danger d-flex align-items-start ">
                          <i className="mdi mdi-close-circle text-danger me-2 font-size-16 px-1"></i>
                          <span>{msg}</span>
                        </li>
                      ))}
                    </>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Modal>





      {/* othe model */}
      <Modal
        isOpen={showExpiryModal.Show}
        toggle={toggle}
        className="modal-dialog-centered"
      >
        <div
          style={{
            width: "120%",
            margin: "auto",
          }}
        >
          <div className="p-4 bg-light rounded shadow-sm">
            <h3 className="mb-3 text-center">
              Update Scheme Expiry
            </h3>
            <hr />
            <Row className="mb-3">
              <Col sm="6">
                <FormGroup>
                  <Label>From Date</Label>

                  <C_DatePicker
                    name="FromPeriod"
                    options={{
                      altInput: true,
                      altFormat: "d-m-Y",
                      dateFormat: "Y-m-d",
                    }}
                    value={showExpiryModal.Data.FromPeriod}
                    onChange={([date]) => {
                      setShowExpiryModal(prev => {
                        return {
                          ...prev,
                          Data: {
                            ...prev.Data,
                            FromPeriod: _cfunc.date_ymd_func(date)
                          }
                        };
                      });
                    }}
                  />
                </FormGroup>
              </Col>

              <Col sm="6">
                <FormGroup>
                  <Label>To Date</Label>

                  <C_DatePicker
                    name="ToPeriod"
                    options={{
                      minDate: showExpiryModal.Data.ToPeriod,
                      altInput: true,
                      altFormat: "d-m-Y",
                      dateFormat: "Y-m-d",
                    }}
                    value={showExpiryModal.Data.ToPeriod}
                    onChange={([date]) => {
                      setShowExpiryModal((prev) => {
                        return {
                          ...prev,
                          Data: {
                            ...prev.Data,
                            ToPeriod: _cfunc.date_ymd_func(date)
                          }

                        };
                      });
                    }}
                  />
                </FormGroup>
              </Col>


            </Row>
            <Row>
              <Col sm="4">
                <FormGroup>
                  <div className="d-flex align-items-center">
                    <Label className="mb-0 me-5">Is Active</Label>

                    <div className="form-check form-switch mb-0">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        style={{ transform: "scale(1.4)" }}
                        checked={showExpiryModal.Data.IsActive || false}
                        onChange={(e) => {
                          setShowExpiryModal(prev => ({
                            ...prev,
                            Data: {
                              ...prev.Data,
                              IsActive: e.target.checked
                            }
                          }))
                        }}
                      />
                    </div>
                  </div>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col className="text-end">
                <Button
                  color="secondary"
                  className="me-2"
                  onClick={toggle}
                >
                  Cancel
                </Button>

                <Button
                  color="primary"
                  onClick={handleSave}
                >
                  Update
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </Modal>

    </React.Fragment>
  )
}

export default SchemeMasterList;

